const dateObj = new Date();
export const moSelectionInitialState = {
    moDataAll: [],
    totalCount: 0,
    filteredMoData: [],
    searchCriteria: {
        moNumber: '',
        moDescription: '',
        functionalLocation: ''
    },
    tableLoading: true,
    searchedMoData: [],
    startDate: new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate() - 30),
    endDate: new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate() + 35),
    testStatusFilterMo: 'All',
};
